import React,{ useState } from "react";
import { injectIntl } from "react-intl";
import { i18nIntl } from "../../lib/ep";

import { BackButton, SecondaryButton } from "./ActionButton";
import BulkImageUploader from "./BulkImageUploader";
import ButtonCollection from "./ButtonCollection";
import FloatingLayer from "./FloatingLayer";
import Input from "./Input";
import SaveButton from "./SaveButton";
import SectionTitle from "./SectionTitle";
import TextArea from "./TextArea";

import IconedSelectorItems from "../wrappers/IconedSelectorItems";

const AddMenu = ({ addField, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const available_options = [{
	// 	id:'single',
	// 	name:"Add one by one",
	// 	cta_label:"Continue",
	// }, {
		id:'bulk',
		name:i18n("Add in bulk by text"),
		cta_label:"Continue",
	}, {
		id:'images',
		name:i18n("Add in bulk by image"),
		cta_label:"Continue",
	}];

	let add_items_options = [];
	if(props.type.add_options == undefined) {
		add_items_options = available_options;
	} else {
		for(let i in props.type.add_options) {
			if(typeof props.type.add_options[i] === 'object') {
				const method = available_options.find((o) => ( o.id == props.type.add_options[i].type ));
				add_items_options.push({ ...method, config:props.type.add_options[i].config, contract:props.type.add_options[i].contract });
				continue;
			}
			add_items_options.push(available_options.find((o) => ( o.id == props.type.add_options[i] )));
		}
	}

	const [ state, setState ] = useState({ add_type:add_items_options.length == 1 ? add_items_options[0].id  :false, item:"" });

	const selectAddingItemsOption = (type) => {
		if(type === false) {
			setState((s) => ({ ...s, add_type:false }));
			return;
		}

		if(type.id == 'single') {
			addField(props.type.type);
			props.close()
			return;
		}

		setState((s) => ({ ...s, add_type:type.id }));
	};

	const change = (k, v) => {
		setState((s) => ({ ...s, [k]:v }));
	};

	const addFields = (e,cb) => {
		const fields = state.item.split("\n").map(field => ({ name:field}));
		fields.map(f=>{
			props.add(f);
		})
		props.close();
	};

	const nameAutoTransform = (v) => {
		if(props.nameAutoTransform != undefined) return props.nameAutoTransform(v);
		return v;
	};

	const uploadImages = (k, v, name, full) => {
		if(k == 'full_image') return;

		const [ filename, ext ] = name.split('.');

		const data = {
			name:nameAutoTransform(filename),
			image:v,
			full_image:full
		}
		props.add(data);
	};

	return (
		<FloatingLayer _class={{size:'small'}} backButton={props.close}>
			<div>
				{(state.add_type == 'single') && (
					<div>
						<SectionTitle>Add items</SectionTitle>

						<Input
							_class={{first:true, size:50}}
							value={state.item}
							change={change}
							name="item"
							max_length={25}
						>Item name</Input>
					</div>
				)}

				{(state.add_type == 'bulk') && (
					<div>
						<SectionTitle>Add items</SectionTitle>

						<TextArea
							_class={{first:true}}
							value={state.item}
							change={change}
							name="item"
							after_component={`[${i18n("Add one item name per line")}]`}
						>Item names</TextArea>
					</div>
				)}

				{(state.add_type == 'images') && (
					<div>
						<SectionTitle>Add items</SectionTitle>

						<BulkImageUploader
							auto_url={props.upload.auto_url}
							auto_type={props.upload.auto_type}
							max_items={props.max_items}
							change={uploadImages}
							onFinish={() => props.close()}
							size={props.img_size}
							after_component={`[${i18n("The item names will be generated using the filenames of the images")}]`}
						>Item images</BulkImageUploader>
					</div>
				)}

				{(!state.add_type) && (
					<div>
						<SectionTitle>Add items</SectionTitle>

						<IconedSelectorItems
							items={add_items_options}
							onSelectItem={selectAddingItemsOption}
						/>
					</div>
				)}

				<ButtonCollection in_floating={true}>
					<SaveButton
						disabled={(!state.add_type || state.add_type == 'images' || state.item == "") ? true : false}
						color='green'
						onClick={addFields}
					>Create items</SaveButton>

					{(state.add_type !== false && add_items_options.length > 1) ? (
						<BackButton
							onClick={() => selectAddingItemsOption(false)}
						/>
					) : (
						<SecondaryButton
							icon='knk-off'
							onClick={props.close}
						>Close</SecondaryButton>
					)}
				</ButtonCollection>
			</div>
		</FloatingLayer>
	)
}

export default injectIntl(AddMenu);